import React from "react";
import { CheckCircle, Calendar, ShieldCheck, FileText, Sparkles, ExternalLink } from "lucide-react";

export default function Coaching() {
  const bookingUrl = "https://academy.suhasinibasa.com/web/checkout/6a8eb2e3570da12b73781f39";

  const topics = [
    { title: "Career Transition & Pivot", desc: "Shift seamlessly from technical execution roles into senior BA or PM mandates without starting from scratch." },
    { title: "Promotion & Salary Alignment", desc: "Formulate concrete performance evidence metrics and structure double-digit adjustment conversations with senior management." },
    { title: "Stakeholder Management & Friction", desc: "De-escalate unrealistic requirements and scope adjustments with calm, strategic negotiation scripts." },
    { title: "Influence Without formal Authority", desc: "Acquire leadership behaviors and project-steering authority across cross-functional enterprise departments." },
    { title: "Executive Communication & Pitching", desc: "Structure high-level roadmaps, risk reviews, and recommendations with premium brevity and business clarity." },
    { title: "LinkedIn & Corporate Branding", desc: "Set up systematic outreach and visibility workflows to capture key tier-1 recruiter pipelines." }
  ];

  return (
    <div className="relative bg-obsidian text-slate-100 min-h-screen">
      <div className="noise-overlay" />

      {/* Header */}
      <section className="relative py-20 lg:py-28 px-4 sm:px-6 lg:px-12 border-b border-white/5 overflow-hidden">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-gold/5 rounded-full blur-[120px] pointer-events-none" />
        <div className="max-w-4xl mx-auto text-left space-y-6 relative z-10">
          <span className="text-xs uppercase tracking-[0.25em] text-gold font-mono font-bold">1:1 EXECUTIVE PARTNERSHIP</span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-tight">
            A career strategy built around YOU.
          </h1>
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed font-normal">
            Bespoke mentorship tailored specifically to your organization&apos;s internal political structure, stakeholders&apos; communication patterns, and unique professional narrative.
          </p>
        </div>
      </section>

      {/* Topics */}
      <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-12 bg-navy relative border-b border-white/5">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          
          <div className="lg:col-span-7 space-y-8">
            <h2 className="font-display text-2xl sm:text-3xl font-bold text-white">Specific Challenges We Address</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {topics.map((topic, idx) => (
                <div key={idx} className="space-y-2">
                  <h4 className="text-gold font-bold text-sm sm:text-base flex items-center gap-2">
                    <CheckCircle className="w-4 h-4 shrink-0" />
                    {topic.title}
                  </h4>
                  <p className="text-slate-400 text-xs sm:text-sm leading-relaxed">{topic.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="border border-white/10 bg-obsidian p-6 space-y-6">
              <h3 className="font-display text-lg font-bold text-white">Coaching Partnership Specifications</h3>
              <div className="space-y-4 text-xs font-mono text-slate-400">
                <div className="flex justify-between border-b border-white/5 pb-2">
                  <span>Format:</span>
                  <span className="text-white">1:1 Private Zoom Alignment Sessions</span>
                </div>
                <div className="flex justify-between border-b border-white/5 pb-2">
                  <span>Prerequisites:</span>
                  <span className="text-white">Minimum 5 Years Corporate Experience</span>
                </div>
                <div className="flex justify-between border-b border-white/5 pb-2">
                  <span>Support:</span>
                  <span className="text-white">Direct Email &amp; Document Review</span>
                </div>
              </div>
              <a
                href={bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="coaching-booking-cta"
                className="w-full bg-gold hover:bg-gold-hover text-obsidian py-3 font-display font-bold text-xs uppercase tracking-widest block text-center transition-colors duration-200"
              >
                Secure 1:1 consultation
              </a>
            </div>
          </div>

        </div>
      </section>

    </div>
  );
}
